// Account.js

import React, { useEffect, useState } from "react";
import {
  Link,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Editprofile from "./Account/Editprofile";
import ApiRequest, { baseurl } from "../Common/restservice";
import { errorToast } from "../Common/showtoast";
import ImageWithFallback from "../Components/ImageWithFallback";
import banner from "../Assets/Images/homebanner.jpg";
import {
  SlEye,
  SlGameController,
  SlHome,
  SlPower,
  SlSettings,
} from "react-icons/sl";
import { BiCheckShield } from "react-icons/bi";
import KYC from "./Account/KYC";
import Settings from "./Account/Settings";
import Activity from "./Account/Activity";
import { BsShieldCheck } from "react-icons/bs";
import Views from "./Account/Views";

function Account() {
  const [stateObj, setStateObj] = useState({});
  const { pathname } = useLocation();
  const navigate = useNavigate();

  // Function to fetch/refresh profile data. This updates stateObj.
  const GetMyProfile = async (e) => {
    let res = await ApiRequest("accounts.asp", "GET", null, {
      Authorization: localStorage.getItem("token"),
    });
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      return;
    }
    setStateObj(res);
  };

  useEffect(() => {
    GetMyProfile();
  }, []);

  return (
    <>
      <section>
        <div
          className="bannerimg cover-image bg-background3"
          data-bs-image-src={banner}
          style={{ background: `url(${banner}) center 25%` }}
        >
          <div className="header-text mb-0">
            <div className="container">
              <div className="text-center text-white">
                <h1>Account</h1>
                <ol className="breadcrumb text-center">
                  <li className="breadcrumb-item">
                    <Link to={"/account"}>Account</Link>
                  </li>
                  <li
                    className="breadcrumb-item active text-white"
                    aria-current="page"
                  >
                    Profile
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="sptb">
        <div class="container">
          <div class="row">
            <div class="col-xl-3 col-lg-12 col-md-12">
              <div class="card overflow-hidden is-expanded">
                <div class="card-header">
                  <h3 class="card-title">My Account</h3>
                </div>
                <div class="card-body item-user p-5 active">
                  <div class="profile-pic">
                    <div class="profile-pic-img">
                      <span
                        class="bg-success dots"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title=""
                        data-bs-original-title="online"
                        aria-label="online"
                      ></span>
                      <ImageWithFallback
                        src={baseurl + stateObj.profilepic}
                        class="brround"
                        alt="user"
                        style={{ height: "100%", width: "100%" }}
                      />
                    </div>
                    <label class="text-dark">
                      {/* Name displayed here is pulled from stateObj */}
                      <h4 class="mt-3 mb-0 font-weight-semibold">
                        {stateObj.fullname}{" "}
                        {stateObj.activestatus === "Active" ? (
                          <BsShieldCheck color="green" />
                        ) : (
                          ""
                        )}
                      </h4>
                      <label className="mb-1 mt-2">
                        {stateObj.usertype === "freelancer"
                          ? "Freelancer"
                          : "Businesses"}
                      </label>
                      <br />
                      <label className="mb-1">
                        {stateObj.usertypecategory}
                      </label>
                      <br />
                      <label className="my-2">
                        Joined : {stateObj.joiningdate}
                      </label>
                      {/* {stateObj.activestatus === "Active" && (
                        <label className="text-danger">
                          Expire at : {stateObj.renewaldate || "Not yet activated"}
                          <br/> (Days
                          Remain : {stateObj.renewaldays || 0})
                        </label>
                      )} */}
                    </label>
                  </div>
                </div>
                <aside class="app-sidebar doc-sidebar my-dash open">
                  <div class="app-sidebar__user clearfix is-expanded">
                    <ul class="side-menu open">
                      <li class="is-expanded">
                        <Link
                          to={"/account/profile"}
                          class={`side-menu__item ${pathname === "/" ||
                            pathname === "/account" ||
                            pathname === "/account/profile"
                            ? "active"
                            : ""
                            }`}
                        >
                          {/* <i class="side-menu__icon 	icon-user"></i> */}
                          <SlHome class="side-menu__icon" />
                          <span class="side-menu__label"> Dashboard</span>
                        </Link>
                      </li>
                      {stateObj.activestatus === "Active" && (
                        <li class="is-expanded">
                          <Link
                            to={"/account/views"}
                            class={`side-menu__item ${pathname === "/account/views" ? "active" : ""
                              }`}
                          >
                            <SlEye class="side-menu__icon" />
                            <span class="side-menu__label">
                              {" "}
                              Who Viewed My Profile
                            </span>
                          </Link>
                        </li>
                      )}

                      <li>
                        <Link
                          class={`side-menu__item ${pathname === "/account/kyc" ? "active" : ""
                            }`}
                          to="/account/kyc"
                        >
                          <BiCheckShield class="side-menu__icon" />
                          <span class="side-menu__label">KYC</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          class={`side-menu__item ${pathname === "/account/activity" ? "active" : ""
                            }`}
                          to={"/account/activity"}
                        >
                          <SlGameController class="side-menu__icon" />
                          <span class="side-menu__label">Activity</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          class={`side-menu__item ${pathname === "/account/settings" ? "active" : ""
                            }`}
                          to="/account/settings"
                        >
                          <SlSettings class="side-menu__icon" />
                          <span class="side-menu__label">Settings </span>
                        </Link>
                      </li>
                      <li>
                        <a
                          class="side-menu__item"
                          onClick={(e) => {
                            e.preventDefault();
                            localStorage.clear();
                            return navigate("/login");
                          }}
                        >
                          <SlPower class="side-menu__icon" />
                          <span class="side-menu__label">Logout</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </aside>
              </div>
            </div>
            <div class="col-xl-9 col-lg-12 col-md-12">
              <Routes>
                <Route
                  path="/profile"
                  element={
                    <Editprofile
                      stateObj={stateObj}
                      // GetMyProfile is passed down to refresh the parent state
                      GetMyProfile={GetMyProfile}
                    />
                  }
                />
                <Route
                  path="/"
                  element={
                    <Editprofile
                      stateObj={stateObj}
                      GetMyProfile={GetMyProfile}
                    />
                  }
                />
                <Route
                  path="/kyc"
                  element={
                    <KYC stateObj={stateObj} GetMyProfile={GetMyProfile} />
                  }
                />
                <Route
                  path="/settings"
                  element={
                    <Settings stateObj={stateObj} GetMyProfile={GetMyProfile} />
                  }
                />
                <Route
                  path="/activity"
                  element={
                    <Activity stateObj={stateObj} GetMyProfile={GetMyProfile} />
                  }
                />
                <Route
                  path="/views"
                  element={
                    <Views stateObj={stateObj} GetMyProfile={GetMyProfile} />
                  }
                />
                {/* GetWhoViewedList.asp */}
              </Routes>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Account;